var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgEyeCrossedOut = function SvgEyeCrossedOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "#F7941D",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18M10.584 10.587a2 2 0 002.828 2.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.363 5.365A9.466 9.466 0 0112 5c4 0 7.333 2.333 10 7-.778 1.361-1.612 2.524-2.503 3.488m-2.14 1.861C15.726 18.449 13.942 19 12 19c-4 0-7.333-2.333-10-7 1.369-2.395 2.913-4.175 4.632-5.341"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNGNzk0MUQiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgPGxpbmUgeDE9IjMiIHkxPSIzIiB4Mj0iMjEiIHkyPSIyMSIgLz4KICA8cGF0aCBkPSJNMTAuNTg0IDEwLjU4N2EyIDIgMCAwIDAgMi44MjggMi44MyIgLz4KICA8cGF0aCBkPSJNOS4zNjMgNS4zNjVhOS40NjYgOS40NjYgMCAwIDEgMi42MzcgLS4zNjVjNCAwIDcuMzMzIDIuMzMzIDEwIDdjLS43NzggMS4zNjEgLTEuNjEyIDIuNTI0IC0yLjUwMyAzLjQ4OG0tMi4xNCAxLjg2MWMtMS42MzEgMS4xIC0zLjQxNSAxLjY1MSAtNS4zNTcgMS42NTFjLTQgMCAtNy4zMzMgLTIuMzMzIC0xMCAtN2MxLjM2OSAtMi4zOTUgMi45MTMgLTQuMTc1IDQuNjMyIC01LjM0MSIgLz4KPC9zdmc+";
export { SvgEyeCrossedOut as ReactComponent };